import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { jsx } from 'react/jsx-runtime';

var HoverCard = HoverCardPrimitive.Root;
var HoverCardTrigger = HoverCardPrimitive.Trigger;
var HoverCardContent = React.forwardRef(function HoverCardContent2({ className, align = "center", sideOffset = 4, ...props }, ref) {
  return /* @__PURE__ */ jsx(HoverCardPrimitive.Portal, { children: /* @__PURE__ */ jsx(
    HoverCardPrimitive.Content,
    {
      ref,
      align,
      sideOffset,
      className: cn(
        "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out",
        className
      ),
      ...props
    }
  ) });
});

export { HoverCard, HoverCardContent, HoverCardTrigger };
//# sourceMappingURL=chunk-5EZ6UUAR.js.map
//# sourceMappingURL=chunk-5EZ6UUAR.js.map